module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAOCAYAAAA8E3wEAAAAAXNSR0IArs4c6QAAAHhJREFUOE+91MENgCAMQFG5OWpn8GDiyR06LDU1wRiktEXgL/BuPyDiTkTHMiEiOgM7M1DGAGC7wdFowth5wFHoG/uAvdEcK4K90BImgn9RCauCrWgNU0EvqmEm0IpaMDOooVbMBUqoB3ODOerFmsCExhhXfqP3+RdpIpRdsZQDDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_sanjiao.png
// module id = FIwV
// module chunks = 1